import isArray from 'lodash/isArray'
import isDate from 'lodash/isDate'
import isObject from 'lodash/isObject'
import isRegExp from 'lodash/isRegExp'
import isString from 'lodash/isString'
import toPairs from 'lodash/toPairs'

const KLEAR_BIGINT = '__klearBigint'

function isTaggedBigint(o: unknown): o is { __klearBigint: true; v: string } {
  if (!isObject(o)) return false
  const record = o as Record<string, unknown>
  return record[KLEAR_BIGINT] === true && isString(record.v)
}

function isPassthroughObject(value: object): boolean {
  return isDate(value) || value instanceof File || value instanceof Blob || isRegExp(value)
}

function serializePrimitives(value: unknown): unknown {
  // eslint-disable-next-line lodash/prefer-lodash-typecheck -- no lodash equivalent for bigint
  if (typeof value === 'bigint') {
    return { [KLEAR_BIGINT]: true, v: value.toString() }
  }
  if (isArray(value)) {
    return value.map((v) => serializePrimitives(v))
  }
  if (isObject(value)) {
    if (isPassthroughObject(value)) return value
    const out: Record<string, unknown> = {}
    for (const [k, v] of toPairs(value as Record<string, unknown>)) {
      out[k] = serializePrimitives(v)
    }
    return out
  }
  return value
}

function deserializePrimitives(value: unknown): unknown {
  if (isTaggedBigint(value)) {
    return BigInt(value.v)
  }
  if (isArray(value)) {
    return value.map((v) => deserializePrimitives(v))
  }
  if (isObject(value)) {
    if (isPassthroughObject(value)) return value
    const out: Record<string, unknown> = {}
    for (const [k, v] of toPairs(value as Record<string, unknown>)) {
      out[k] = deserializePrimitives(v)
    }
    return out
  }
  return value
}

export const primitiveTransformer = {
  serialize: (data: unknown) => serializePrimitives(data),
  deserialize: (data: unknown) => deserializePrimitives(data)
}
